import gql from 'graphql-tag';
import { useState, useRef } from 'react';

import { AccordionFragment } from '@graphqlTypes';
import AccordionItem from './AccordionItem';
import { Container, RevealWrapper, SectionFooter, SectionHeader } from '@components';
// import { getHighlightMarkup, getLinkData } from '@/core/utils';

import { useViewSize } from '@/providers/ViewSizeContext';
import { useInView } from 'motion/react';
import { AnimVals } from '@/utils/animUtils';

import styles from './Accordion.module.scss';
import className from 'classnames/bind';
const cx = className.bind(styles);

export default function Accordion(props: AccordionFragment) {
  const { headline, subhead, accordions, includeFooter, footer } = props;
  const [activeItem, setActiveItem] = useState<string | null>(null);
  const showHeader = Boolean(headline || subhead);
  const onToggle = (id: string) => {
    setActiveItem(activeItem === id ? null : id);
  };

  // -------------------- Animation

  const rootEl = useRef<HTMLDivElement>(null);
  const { isDesktop } = useViewSize();
  const REVEAL = AnimVals;
  const triggerPercent = isDesktop ? REVEAL.lg.triggerPercent : REVEAL.sm.triggerPercent;
  const isInView = useInView(rootEl, { amount: triggerPercent, once: REVEAL.once });
  const isRevealEnabled = true;

  // -------------------- Render

  return (
    <section className={cx(["accordion"])} ref={rootEl}>
      <RevealWrapper isInView={isInView}>
      <Container>
        { showHeader && (
          <SectionHeader
            headline={headline}
            subhead={subhead}
            isRevealEnabled={isRevealEnabled}
            isInView={isInView}
          />
        )}
        <div className={cx("accordion-list")}>
          {accordions.map((item, index) => (
            <AccordionItem
              isOpen={activeItem === `accordion-item-${index}`}
              index={index}
              onToggle={onToggle}
              key={index}
              content={item}
            />
          ))}
        </div>
        { includeFooter && footer && (
          <SectionFooter
            text={footer.text}
            ctas={footer.ctas}
          />
        )}
      </Container>
      </RevealWrapper>
    </section>
  )
}

Accordion.fragments = {
  entry: gql`
    fragment Accordion on FlexiblePageContentContentAccordionLayout {
      headline
      subhead
      accordions {
        headline
        subhead
        body
        image {
          ...ACFMedia
        }
        cta {
          linkType
          label
          externalLink
          page {
            node {
              uri
            }
          }
        }
      }
      includeFooter
      footer {
        text
        ctas {
          linkType
          label
          externalLink
          page {
            node {
              uri
            }
          }
        }
      }
    }
  `,
};
